.controlBar {
  display: flex;
  flex: 0 0 auto;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5rem;
  max-height: none;
}

.viewerCount,
.controlGroup,
.endControls {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.viewerCount {
  flex-shrink: 0;
  white-space: nowrap;
}

.controlGroup,
.endControls {
  flex-wrap: wrap;
}

.endControls {
  margin-left: auto;
}

.controlBar button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  box-sizing: border-box;
  height: 2.75rem;
  white-space: nowrap;
}

.controlBar button > svg {
  flex-shrink: 0;
  width: 1.25rem;
  height: 1.25rem;
}

.controlBar :global(.lk-button-group) {
  flex-shrink: 0;
  height: 2.75rem;
}

.button {
  --lk-control-bg: #1e1e1e;
  --lk-control-hover-bg: #2b2b2b;
  --lk-control-active-bg: #373737;
  --lk-control-active-hover-bg: #2b2b2b;
}

.button[data-status='LOADING'] {
  --lk-control-bg: #374151;
}

.button[data-status='IN_PROGRESS'] {
  border: 1px solid #dc2626;
}

.button[data-status='FAILED'] {
  --lk-control-bg: #dc2626;
  --lk-control-hover-bg: #b91c1c;
}

.button[data-status='PARTIALLY_FAILED'] {
  --lk-control-bg: #ca8a04;
  --lk-control-hover-bg: #a16207;
}

.loadingIcon {
  animation: spin 1s linear infinite;
}

.activeIcon {
  color: #dc2626;
  animation: pulse 2s ease-in-out infinite;
}

.breakoutLabel {
  font-size: 0.875rem;
  font-weight: 500;
}

.roomsOpen {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: #4ade80;
}

.roomsOpenIndicator {
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  background-color: currentColor;
  animation: pulse 2s ease-in-out infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes pulse {
  50% {
    opacity: 0.5;
  }
}

@media (prefers-reduced-motion: reduce) {
  .loadingIcon,
  .activeIcon,
  .roomsOpenIndicator {
    animation: none;
  }
}
